const STYLE_SEED = 'operations-hub';

const STYLE_SEED_OVERRIDE = `${STYLE_SEED}-`;

export { STYLE_SEED, STYLE_SEED_OVERRIDE };
